import Image from "next/future/image";
import styles from "../styles/CaseStudyHero.module.css";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useState, useEffect } from "react";
import AutoPlayVideo from "./AutoPlayVideo";
import useNextBlurhash from "use-next-blurhash";
const CaseStudyHero = ({
  title,
  subtitle,
  background,
  hasStats = false,
  negativeMarginTop,
}) => {
  const { width } = useWindowDimensions();
  const {
    featuredImage,
    desktopVideo,
    mobileVideo,
    mobileImage,
    lgPosition,
    smPosition,
    textPosition,
    blurHash,
  } = background;
  const [hasVideo, setHasVideo] = useState(false);
  const computedTextPosition =
    (textPosition && `justify-center lg:justify-${textPosition}`) ||
    "justify-end lg:justify-end";

  useEffect(() => {
    if (desktopVideo !== undefined && mobileVideo !== undefined) {
      setHasVideo(true);
    }
  }, [desktopVideo, mobileVideo]);

  const computedImagePosition = width > 768 ? lgPosition : smPosition;
  const [blurDataUrl] = useNextBlurhash(blurHash);

  return (
    <div
      className={`${styles.heroWrapper} relative w-screen ${
        negativeMarginTop ? "-mt-24" : ""
      } bg-black`}
    >
      {!hasVideo && width && (
        <Image
          priority
          src={width > 768 ? featuredImage : mobileImage}
          className={`object-cover object-${computedImagePosition} w-full h-full`}
          alt=""
          placeholder="blur"
          blurDataURL={blurDataUrl}
          fill
        />
      )}
      {hasVideo && (
        <AutoPlayVideo videoSrc={width > 768 ? desktopVideo : mobileVideo} />
      )}
      <div
        className={`relative z-10 flex flex-col ${computedTextPosition} h-full max-w-screen-xl px-6 mx-auto sm:px-6`}
      >
        <div
          className={`flex flex-col gap-5 lg:max-w-heroWidth ${
            !textPosition && hasStats
              ? "mb-heroSpacingMobile lg:mb-heroSpacing"
              : "mb-noStatsHeroSpacingMobile lg:mb-noStatsHeroSpacing"
          }`}
        >
          <h2 className="font-extrabold leading-none text-white text-3xl md:text-5xl lg:text-7xl">
            {subtitle}
          </h2>
        </div>
      </div>
    </div>
  );
};
export default CaseStudyHero;
